import * as React from 'react';
import * as style from './AwardCard.css';
import { Image, Responsive, UIText2, UIText3, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { AwardCardTooltip } from './AwardCardTooltip';

interface IAwardCardProps {
  title: string;
  image: string;
}

export const AwardCard = ({ title, image }: IAwardCardProps) => {
  const deviceType = useDeviceType();

  const height = React.useMemo(() => {
    return deviceType === 'desktop' ? 66 : 80;
  }, [deviceType]);

  const width = React.useMemo(() => {
    return deviceType === 'desktop' ? 200 : 220;
  }, [deviceType]);

  return (
    <AwardCardTooltip text={title}>
      <div className={style['card']}>
        <div className={clsx(style['image'], deviceType === 'desktop' && style['image--desktop'])}>
          <Image src={image} alt={title} height={height} width={width} objectFit="contain" preloader={false} />
        </div>
        <div className={style['text']}>
          <div className={style['text__inner']}>
            <UIText2>{title}</UIText2>
          </div>
        </div>
        <Responsive desktop>
          <div className={style['overlay']}>
            <div className={style['overlay__inner']}>
              <UIText3>{title}</UIText3>
            </div>
          </div>
        </Responsive>
      </div>
    </AwardCardTooltip>
  );
};
